import React, { Component, useContext } from 'react'
import { Row, Col, Form, Input, Button, Typography, Modal, message, Checkbox, Divider } from 'antd';
import axios from 'axios'
import { FaFacebook } from "react-icons/fa";
import { Navigate, Link, useNavigate } from 'react-router-dom';

import { User, SetUser } from '../../Hooks/Logged';
//css
import '../../Styles/Global/auth.scss';
import GoogleRegister  from '../Widgets/Google/GoogleRegister';
import FacebookLogin  from '../Widgets/Facebook/FacebookLogin';
import { SetCarrito } from '../../Hooks/Carrito';
import GoogleSignInButton from '../ButtonSignIn/GoogleSignInButton';
import AppleSignInButton from '../ButtonSignIn/AppleSignInButton';

const { Title, Text } = Typography

/**
 * 
 * @class Login
 * @extends {Component}
 * @description Componente Login para inicio de sesion
 */
class Login extends Component {
	constructor(props) {
		super(props);
		this.state = {

		}
	}

	form = React.createRef()

	/**
	 * @memberof Login
	 *
	 * @method handleSubmit
	 * @description  Envia los datos del formulario al Servidor
	 *
	 * @param values (array)
	 * Contiene los campos del formulario para registrar al usuario
	 *
	 * @returns response (array)
	 **/
	handleSubmit = (values) => {
		this.setState({ loading: true })
		axios.post('/login', {
			email: values.email,
			password: values.password
		})
			.then(({ data, headers }) => {
				const { setUser } = this.props;

				axios.defaults.headers.post["Authorization"] = headers.authorization;

				sessionStorage.setItem('token', headers.authorization);
				axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');

				sessionStorage.setItem('user', JSON.stringify(data.user));
				setUser(data.user);
				this.props.navigate(data.user?.cliente_id ? '/customer/dashboard' : (data.user?.rol_id.permisos.dashboard)? '/admin/dashboard': '/admin/');

				//console.log('permiso dashboard = ', data.user?.rol_id.permisos.dashboard)
				//this.props.navigate(data.user?.cliente_id ? '/customer/dashboard' : (data.user?.rol_id.permisos.dashboard)? '/admin/dashboard': '/admin/');
			})
			.catch((error) => {

				Modal.error({ title: "Incorrect Credentials", content: error?.response?.data?.message ?? "Try Later" })

				this.setState({ loading: false });
			})
	};





	

	cerrarSesion = () => {
		this.props.setUser(undefined);
		sessionStorage.clear();
		this.props.navigate("/")
		this.props.setCart({})

		if(window.FB){
        	window.FB.logout(function(response) {
        		console.log("response", response);
			});
        }

	};


	render() {
		return (
			<Row className='layout-login'>
				<Col xs={24} lg={24} xl={10} className="col-welcome">
					<Row>
						<a href={'/'}>
							<img width="400" src="/logo-white.png" alt="Sneacare" className='logo-login' />
						</a>
					</Row>
				</Col>
				<Col xs={24} lg={24} xl={14}>
					{
						this.props.user ? (
							<div className="login-form-container">
								<div className="login-form">
									<Title level={3} className="h3-title" style={{ marginBottom: '3em' }}>Welcome Back!</Title>
									<Title align="center" style={{ marginTop: '1em' }}>{this.props?.user?.nombre} {this.props?.user?.apellidos}</Title>
									<Title level={4} align="center" style={{ marginBottom: '1em' }}>{this.props?.user?.email}</Title>
									<Button type="primary" htmlType="submit" block size="large" onClick={() => this.props.navigate(this.props.user?.cliente_id ? '/customer/dashboard' : '/admin/dashboard')} >Continue</Button>
									<Button type="link" htmlType="submit" block size="large" onClick={() => this.cerrarSesion()}>Log Out</Button>
								</div>
							</div>
						) : (
							<div className='login-form-container'>
								<Form 
									onFinish={this.handleSubmit} 
									layout={"vertical"} 
									requiredMark={false} 
									className='login-form'
									ref={this.form}
								>
									<Title level={3} className="h3-title">Welcome Back!</Title>
									<Form.Item
										className='input-email'
										name="email"
										label="Email"
										rules={[
											{ required: true, message: 'Please, enter your email' },
											{
												type: 'email',
												message: 'Email is not valid',
											},
											{
								            	validator: (_, value) => {
									              	// Transformar el valor a minúsculas
									              	const lowercaseValue = value.toLowerCase();
									              	if (value !== lowercaseValue) this.form.current.setFieldsValue({ email: lowercaseValue });
								          			return Promise.resolve();
								            	},
								        	}
										]}>
										<Input placeholder="example@mail.com" size="large" className="input-login" />
									</Form.Item>
									<Form.Item
										label="Password"
										name="password"
										rules={[{ required: true, message: 'Enter your password' }]}>
										<Input.Password placeholder="********" size="large" />
									</Form.Item>
									<Form.Item
										name="keep_session"
									>
										<Checkbox>Keep Session</Checkbox>
									</Form.Item>
									<Form.Item>
										<Button type="primary" htmlType="submit" block size="large" >Log In</Button>
									</Form.Item>

									<Divider orientation="center">
										<span style={{ fontSize: 'clamp(14px, 2vw, 16px)', color: '#ccc', fontWeight: 400 }}>
											Or
										</span>
									</Divider>

									<Row gutter={[0, 12]}>
										<Col span={24}>
											<GoogleSignInButton 
												setUser={this.props.setUser} 
												navigate={this.props.navigate} 
											/>
										</Col>
										<Col span={24}>
   											<AppleSignInButton 
												setUser={this.props.setUser} 
												navigate={this.props.navigate} 
											/>
 										</Col>
									</Row>
									
									
									
									<Text className="mt-1" style={{ fontSize: '18px' }} >Do you not have an account? <Link to="/register">Sign Up</Link></Text>
								{
									!this.props.user && <div className='link-password-recovery'>
										Did you Forget your Password? <Link style={{ color: '#5452F6' }} to='/password/recovery'>Restore it here</Link>
									</div>
								}
								</Form>
							</div>
						)
					}

				</Col>
				
			</Row>
		)
	}
}

export default function View(props) {

	let user = useContext(User)
	const setUser = useContext(SetUser)
	const setCart = useContext(SetCarrito)

	return <Login {...props} user={user} setUser={setUser} navigate={useNavigate()} setCart={setCart}/>
}